import React from 'react'
import PrimaryButton from './ButtonPrimaryStyle'
import { IButtonPrimary } from './Types'

export default function ButtonPrimary(props: IButtonPrimary): JSX.Element {
  return (
    <>
      <PrimaryButton.ButtonStyle
        color={props.color}
        onClick={props.onClick}
        width={props.width}
        variant={props.variant}
        disabled={props.disabled}
        sx={props.sx}
      >
        {props.buttonTitle}
      </PrimaryButton.ButtonStyle>
    </>
  )
}
